module.exports = __webpack_public_path__ + "img/Girl_020035.c7854cd4.png";